import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultMethodResource,
    MethodMutationResourceSchema,
    type MethodResource,
    useMethodActions,
} from '../../../../../resource/resources/artifacts/method/methodResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { MethodContent } from './MethodContent';

export const MethodCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: MethodResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const methodActions = useMethodActions();
    const addMethod = methodActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: MethodMutationResourceSchema,
        defaultValues: {
            ...defaultMethodResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addMethod.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Method'}
            resourceType={ResourceType.METHOD}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <MethodContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
